<template>
  <ValidationObserver
    class="needs-validation form-custom-format"
    v-bind:class="{ 'was-validated': validated }"
    tag="form"
    ref="observer"
    v-slot="{ passes }"
    @submit.prevent="onSubmitForm"
  >
    <el-dialog
      :modal="true"
      ref="window"
      :fullscreen="true"
      :title="'GENERATE UPC CODE'"
      :visible.sync="syncModal"
      :close-on-click-modal="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      class="text-left bulk-create-dialog"
      :formStatus="formStatus"
      @dialog-state="dialogState"
      :group="group"
      :showClose="!processing"
    >


    <div class="d-inline-flex p-1">
            <el-radio-group v-model="connection" class="border border-info p-2 rounded">
              <el-radio label="QATL_PRODUCTION" class="mb-0">QATL_PRODUCTION</el-radio>
              <template v-if="checkSystemSupport">
                <el-radio label="QATL_DEV" class="mb-0">QATL_DEV</el-radio>
              </template>
            </el-radio-group>
            
        </div>
    <div class="alert alert-warning m-0">
      <p class="mb-0"><i class="el-icon-info"></i><strong>Info!</strong> UPC Generator will generate a unique UPC for each item.Existing item with UPC code will be skipped.</p>
    </div>
      <div ref="jspreadsheet"></div>
      <template #footer>
        <div class="d-flex">
            <template v-if="formStatus == 'create'">
              <template v-if="processing == true">
                <mdb-btn color="elegant" size="sm" disabled>
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Processing...
                </mdb-btn>
              </template>
              <template v-else>
                <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm)">
                  <i class="el-icon-check text-white cursor-pointer"></i> Save
                </mdb-btn>
              </template>
              <mdb-btn color="grey" size="sm" @click="passes(clearForm)">
                <i class="el-icon-copy-document text-white cursor-pointer"></i> Clear
              </mdb-btn>
             
            </template>
            <mdb-btn color="grey" size="sm" @click="closeDialog">
              <i class="el-icon-close text-white cursor-pointer"></i> Close
            </mdb-btn>
        </div>
      </template>
    </el-dialog>
  </ValidationObserver>
</template>
<script>
import { mdbBtn } from "mdbvue";
import { ValidationObserver } from "vee-validate";
import { mapActions, mapGetters } from "vuex";
import jspreadsheet from "../../jsexcel/jexcel";

import { MessageBox, Message } from "element-ui";
import state from "./store/state";

const dropdownUomFilter = function (instance, cell, c, r, source) {
  console.log("source", source);
  var value = instance.jexcel.getValueFromCoords(5, r);

  console.log("value",value)
  const filterResult = source.filter((item) => {
    return item.UgpEntry == value;
  }, []);
  return filterResult;
};

export default {
  components: {
    mdbBtn,
    ValidationObserver,
  },
  props: {
    group: {
      type: Number,
      default: 1,
    },
  },

  data(){
    const self = this;
    return {
    syncModal: false,
    validated: false,
    formStatus: "create",
    form: null,
    formData: null,
    formDataOrginal: null,
    formLoading: false,
    processing: false,
    showError: false,
    group2: 3,
    jspreadsheet: null,
    activeStep: 0,
    connection : "QATL_PRODUCTION",
    jspreadsheetGridOptions: {
      download: false,
      allowDeleteColumn: false,
      allowRenameColumn: false,
      defaultColAlign: "left",
      csvHeader: true,
      tableWidth: "100%",
      tableHeight: "calc(100vh - 170px)",
      tableOverflow: true,
      data: [[]],
      minDimensions: [3, 50],
      onCopy: null,
      selectionCopy: false,
      allowCopy: true,
      columns: [
        {
          type: "text",
          width: "200px",
          title: "Item Code",
          name: "ItemCode",
          readOnly: false,
          primaryKey: false,
        },
        {
          type: "text",
          width: "200px",
          title: "Item Name",
          name: "ItemName",
          readOnly: false,
        },
        {
          width: "200px",
          title: "UOM",
          name: "uom",

           dropdown: true,
          type: "dropdown",
          source: self.measurementComputed,
        },
        {
          type: "text",
          width: "200px",
          title: "UPC",
          name: "upc",
          readOnly: false,
        },
        {
          type: "text",
          width: "340px",
          title: "Response",
          name: "message",
        },
      ],

      contextMenu: function () {
        return false;
      },
      /* onchange: function(instance, domElmentCell, column, row){
          self.recalculateDimension(instance, column, row)
      }, */

      onchange: function(domElement, domElmentCell, column, row, value,oldValue){
        if(column == 0){
            if((value != null && value != '' && value != oldValue) || (oldValue == '' && oldValue == null)){
              self.fnGetItem(value,row)
            }
        }

        if(column == 2){
            if((value != null && value != '' && value != oldValue) || (oldValue == '' && oldValue == null)){
                self.getItemBarcode(value, row)
            }
        }
      },

    },

    isIndeterminate: false,
    checkAll: true,
    checkedOptions: [
      "group",
      "brand",
      "area",
      "category",
      "collection",
    ],
    checkboxOptions: [
    ],

    postedData: [],
    unit_of_measurements: [],
    ...state,
  }},
  inject: [],
  created() {
    this.formData = JSON.parse(JSON.stringify(this.formObject));
    this.formDataOrginal = JSON.parse(JSON.stringify(this.formObject));
  },
  mounted() {
        const self = this;
        self.getUnitOfMeasurementGroups({
            'connection' : self.connection
        }).then(response => {
            self.unit_of_measurements = response.map(e => {
                return {
                    label : `${e.UomEntry} - ${e.UomCode}`,
                    code : e.UomEntry,
                    UomEntry : e.UomEntry,
                    UgpEntry : e.UgpEntry,
                    
                }
            },[])
        })
    },
  methods: {
      
    ...mapActions('UnitOfMeasurementModule',['getUnitOfMeasurementGroups']),
    ...mapActions("UpcGeneratorModule", ["checkRecord","generateUpcCode"]),
    createPopupTable(jspreadsheetGridOptions) {
      const container = this.$refs.jspreadsheet;
      container.innerHTML = "";
      this.jspreadsheet =  jspreadsheet(container, {
        ...jspreadsheetGridOptions,
        data: jspreadsheetGridOptions.data || [],
      });

      Object.assign(this, this.jspreadsheet);
    },

    async recreateSpreadsheet() {
      await this.jspreadsheet.destroy();
    },
    /* start */

    optionsHandler() {
    },

    /* end */

    openDialog() {
      this.syncModal = true;
      this.formResetter();
      this.formStatus = "create";
    },
    closeDialog() {
      this.syncModal = false;
      this.formResetter();
    },

    onSubmitCopyTemplate() {
      const selectedColumns = this.checkboxOptions.filter((item) => {
        return this.checkedOptions.includes(item.value);
      }, []);

      var txt = "Series\t";
      if (selectedColumns.length > 0) {
        selectedColumns.forEach((element) => {
          txt += element.label + "\t";
        });
        txt += "\n";
      }

      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.setAttribute("id", "dummy_id");
      document.getElementById("dummy_id").value = txt;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);

      Message.success({
        message: "Copied!",
      });
    },

    onSubmitBack() {
      const self = this;
      MessageBox.confirm("Are you sure you want to go back?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          self.formStatus = "select";
          self.form = self.formVar();
          requestAnimationFrame(() => {
            self.$refs.observer.reset();
          });
          self.validated = false;
          self.formLoading = false;
          if (self.jspreadsheet) {
            self.jspreadsheet.destroy();
          }
        })
        .catch(() => {
          return;
        });
    },

    onSubmitForm() {
      const self = this;

      if (this.processing) {
        return false;
      }

      const tableData = this.jspreadsheet.getJson();

      const hasInvalidRow = tableData.filter((item) => item.isValid === true).length;

      if(hasInvalidRow > 0){
        Message.error({
          message: "Invalid Data",
        });
        return false;
      }


      const isTableIsEmpty = tableData.filter((item) => item.series !== "").length;

      if(isTableIsEmpty == 0){
        Message.error({
          message: "Invalid Data",
        });
        return false;
      }

      MessageBox.confirm(
        "Warning: Are you sure you want to generate UPC?",
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          if (tableData.length > 0) {
            this.postCounter = 0;
            this.dataLength = tableData.filter((item) => item.series !== "").length;

            
            if (this.dataLength > 0) {
              const validData = tableData
              .filter((item) => item.ItemCode !== "")
              .map((item) => {
                  return { ...item, completed: false };
                });

                console.log("validData", validData);
                const tableArrayData = this.jspreadsheet.getData();

                const filteredTableArrayData = tableArrayData.filter((row) => row[0]?.trim() !== "");

                self.jspreadsheetGridOptions.data = filteredTableArrayData;
                console.log("filteredTableArrayData", self.jspreadsheetGridOptions);
                self.$nextTick(async () => {

             /*      if (self.jspreadsheet) {
                    self.jspreadsheet.destroy();
                    self.jspreadsheet = null;
                  }

                  await self.initliazePopupTable() */

                  console.log("dataLength", validData);
                  self.postedData = JSON.parse(JSON.stringify(validData));
                  let chain = Promise.resolve();
                  validData.forEach((element, forIndex) => {

                    if(element.isBarcodeExist){
                      self.setRowMessage(forIndex,"Skipped...");
                      self.setRowBackgroundStyle(forIndex, '#fff3cd');
                      self.$set(self.postedData[forIndex], "completed", true); 
                      return;
                    }
                    chain = chain.then(async () => {
                      self.setRowBackgroundStyle(forIndex,'transparent')
                      self.setRowMessage(forIndex,"Please wait...")

                      return await self
                        .generateUpcCode({  ...element,
                          connection : self.connection,
                          index: forIndex })
                        .then(async (response) => {

                          console.log("response",response)
                          self.setRowBackgroundStyle(forIndex,'#00c851')
                          self.setRowMessage(forIndex,response.message)
                          self.postCounter++;
                          self.$set(self.postedData[forIndex], "completed", true);
                          self.setRowUPC(forIndex,response.data.Barcode);
                          const existingBarcodes = await self.getExistBarcodes(forIndex);
                          const hasMatch = existingBarcodes.some(
                            (b) => b.UomEntry === response.data.UoMEntry
                          );

                          const updatedBarcodes = hasMatch
                            ? existingBarcodes.map((b) =>
                                b.UomEntry === response.data.UoMEntry
                                  ? { ...b, ...response.data, UomEntry: response.data.UoMEntry }
                                  : b
                              )
                            : [...existingBarcodes, response.data];

                            console.log("existingBarcodes",existingBarcodes)
                            console.log("updatedBarcodes",updatedBarcodes)
                            console.log("forIndex",forIndex)
                          await self.setRowBarcodes(forIndex, updatedBarcodes);
                          self.setRowBarcodeExist(forIndex, true);
                        })
                        .catch((error) => {
                          console.log(error.response);
                          const errors = error.response.data.errors || {};
                          let errorMessage = "";
                          errorMessage = Object.keys(errors)
                            .map((field) => `${field}: ${errors[field][0]}`)
                            .join(", ");

                          const data = error.response.data?.data;
                          if(data){
                            self.setRowUPC(forIndex,data.Barcode);
                          }

                          self.setRowBackgroundStyle(forIndex,'#fb3')
                          self.setRowMessage(forIndex,errorMessage)
                          self.postCounter++;
                          self.$set(self.postedData[forIndex], "completed", true);
                          self.postCounter++;
                          self.$set(self.postedData[forIndex], "completed", true);
                        });
                    });
                  });
                  chain.finally(() => {
                    console.log("All records processed.");
                    this.processing = false;
                  });
                })



              
            }
          }
        })
        .catch((error) => {
          // Handle the case where the user cancels the confirmation dialog
          console.log("Confirmation dialog was cancelled.", error);
        }); 
    },

    formResetter() {
      this.form = this.formVar();
      requestAnimationFrame(() => {
        this.$refs.observer.reset();
      });
      this.validated = false;
      this.formLoading = false;
      this.processing = false;
      this.setFormStatusCreate();

      if (this.jspreadsheet) {
        this.jspreadsheet.destroy();
      }
    },

    dialogState(state) {
      this.optionsHandler();
      if (!state) {
        this.formResetter();
        return;
      }
      if (this.FormStatus == "create") {
        this.formResetter();
      }
    },

    formVar() {
      return {
        items: [],
      };
    },
    setFormStatusCreate() {
      this.formStatus = "create";
    },

    handleCheckAllChange(val) {
      this.checkedOptions = val ? this.checkboxOptions.map((i) => i.value, []) : [];
      this.isIndeterminate = false;
    },
    handleCheckedOptionsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.checkboxOptions.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.checkboxOptions.length;
    },

    iterateAlphabetByNumber(numColumns) {
      const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const columns = [];

      for (let i = 0; i < numColumns; i++) {
        let label = "";
        let index = i;
        while (index >= 0) {
          label = alphabet[index % 26] + label;
          index = Math.floor(index / 26) - 1;
        }

        columns.push(label);
      }
      return columns;
    },
    clearForm() {
      this.jspreadsheetGridOptions.data = [];
      this.recreateSpreadsheet();
      this.createPopupTable({
        ...this.jspreadsheetGridOptions,
        data: this.jspreadsheetGridOptions.data,
      });
    },

    jspreadsheetHeaders(){
            return this.jspreadsheetGridOptions.columns.map(i=>i.name,[])
        },

      recalculateDimension(instance, column, row) {
          const self = this;
          const headers = self.jspreadsheetHeaders()

          const seriesIndex = headers.indexOf('series')
          const seriesValue = instance.getValueFromCoords(seriesIndex, row)
          console.log("seriesValue", seriesValue);
          console.log("column", column);
          console.log("row", row);
      },
        async initliazePopupTable() {
            const self = this;
            this.formResetter();
            this.formStatus = 'create';
            const finalColumns = [
              {
                type: "text",
                width: "200px",
                title: "Item Code",
                name: "ItemCode",
                readOnly: false,
                primaryKey: false,
              },
              {
                type: "text",
                width: "300px",
                title: "Item Name",
                name: "ItemName",
                readOnly: true,
              },
              {
                width: "200px",
                title: "UOM",
                name: "UomEntry",
                dropdown: true,
                type: "dropdown",
                source: self.measurementComputed,
                filter : dropdownUomFilter,
                autocomplete :true,
                multiple :false
              },
              {
                type: "text",
                width: "200px",
                title: "UPC",
                name: "upc",
                readOnly: true,
              },
              {
                type: "text",
                width: "340px",
                title: "Response",
                name: "message",
              },
              {
                type : "hidden",
                name : "UgpEntry",
                title: "UgpEntry",
              },
              {
                type : "hidden",
                name : "barcodes",
                title: "Barcodes",
              },

              {
                type : "hidden",
                name : "isValid",
                title: "isValid",
              },
              {
                type : "hidden",
                name : "isBarcodeExist",
                title: "isBarcodeExist",
              },
              
            ];
             this.$nextTick(() => {
                this.jspreadsheetGridOptions.tableWidth = "100%";
                this.jspreadsheetGridOptions.columns = finalColumns;

                console.log("filteredTableArrayData", this.jspreadsheetGridOptions);

                this.createPopupTable(this.jspreadsheetGridOptions);
            });
        },

        setRowBackgroundStyle(rowIndex,backgroundColor){
          const self = this
          const columns = ['A', 'B', 'C', 'D', 'E', 'F'];
          for (const col of columns) {
            self.jspreadsheet.setStyle(`${col}${rowIndex + 1}`, 'background-color', backgroundColor, true);
          }
        },
        setRowMessage(rowIndex,message = ''){
          this.jspreadsheet.setValueFromCoords(4, rowIndex, message, true);
        },
        setRowisInvalid(rowIndex,status = false){
          this.jspreadsheet.setValueFromCoords(7, rowIndex, status, true);
        },
        setRowBarcodeExist(rowIndex,value = false){
          this.jspreadsheet.setValueFromCoords(8, rowIndex, value, true);
        },
        setRowUPC(rowIndex,value = ""){
          this.jspreadsheet.setValueFromCoords(3, rowIndex, value, true);
        },
        async setRowBarcodes(rowIndex,value = []){
          await this.jspreadsheet.setValueFromCoords(6, rowIndex, value, true);
        },
        async getExistBarcodes(rowIndex){
          const self = this;
          const col = 6;
          const rowData = await self.jspreadsheet.getRowData(rowIndex);
          if (Array.isArray(rowData)) {
            return rowData[col];
          }
          return [];
        },
        async getRowBarcodeExist(rowIndex) {
          const self = this;
          const col = 8;
          const rowData = await self.jspreadsheet.getRowData(rowIndex);
          if (Array.isArray(rowData)) {
            return Boolean(rowData[col]);
          }
          return false;
        },

        async getItemBarcode(Uom, index) {
          const self = this;
          const rowIndex = parseInt(index);
          const rowData = await self.jspreadsheet.getRowData(index);
          const colToCheck = 6;
          let backgroundColor = 'transparent';
          let columnThree = '';
          let message = '';
          let columnSeven = false;
          let barcodeExist = await self.getRowBarcodeExist();

          console.log("barcodeExist",barcodeExist)
          if (Array.isArray(rowData) && Array.isArray(rowData[colToCheck])) {
            
            const barcodeData = rowData[colToCheck].find(
              (item) => parseInt(item.UomEntry) === parseInt(Uom)
            );

            if (typeof barcodeData === 'undefined') {
              message = 'Invalid UOM';
              backgroundColor = 'rgb(255, 200, 200)';
              columnSeven = true
              barcodeExist = false
            } else if (barcodeData.Barcode) {

              if(barcodeData.Barcode.length === 14){
                columnThree = barcodeData.Barcode;
                message = 'Barcode already exists.';
                backgroundColor = '#fff3cd';
                columnSeven = false
                barcodeExist = true
              }
            }
          }

          self.jspreadsheet.setValueFromCoords(3, index, columnThree, true);
          self.setRowMessage(index,message)
          self.setRowisInvalid(index, columnSeven)
          self.setRowBackgroundStyle(rowIndex,backgroundColor)
          self.setRowBarcodeExist(index,barcodeExist)
        },
      async fnGetItem(itemCode, index){
        const self = this;
        const parseIntIndex = parseInt(index)
        self.setRowMessage(index,"Please wait...")
        self.setRowBarcodeExist(index,false)
        await this.checkRecord({item : itemCode, index : index, connection : self.connection}).then((response)=> {
          const {data : res} = response

          console.log("checkRecord res",res)
          let backgroundColor = 'transparent'
          let message = '';
            self.jspreadsheet.setValueFromCoords(0,index,res.ItemCode,true)
            self.jspreadsheet.setValueFromCoords(1,index,res.ItemName,true)
            self.jspreadsheet.setValueFromCoords(2,index,res.UomEntry,true)

            if(res.Barcode != null && res.Barcode !== ""){
              self.jspreadsheet.setValueFromCoords(3,index,res.Barcode,true)
              message = 'Barcode already exist'
              backgroundColor = '#fff3cd';
              self.setRowBarcodeExist(index,true)
            }
            self.jspreadsheet.setValueFromCoords(5,index,res.UgpEntry,true)

            self.jspreadsheet.setValueFromCoords(6,index,res.ItemBarCodeCollection,true)
            self.setRowMessage(index,message)
            self.setRowBackgroundStyle(parseIntIndex,backgroundColor)
            self.setRowisInvalid(parseIntIndex, false)
        }).catch(() => {
          const parseIntIndex = parseInt(index)
          let backgroundColor = 'rgb(255 200 200)';
          if(( parseIntIndex % 2) == 1){
            backgroundColor = 'rgb(233 167 167)';            
          }

            self.jspreadsheet.setValueFromCoords(1,index,"",true)
            self.jspreadsheet.setValueFromCoords(2,index,"",true)
            self.jspreadsheet.setValueFromCoords(3,index,"",true)
            self.setRowMessage(index,"Item Not found")
            self.setRowBackgroundStyle(parseIntIndex,backgroundColor)
            self.setRowisInvalid(parseIntIndex, true)
            

        })
    },

  },

  computed: {
    ...mapGetters("UpcGeneratorModule", {
      formRecord: "formData",
      viewLoading: "getLoading",
      postLoading: "postLoading",
      formObject: "initialFormObject",
    }),
    isAllCompleted: function () {
      return this.postedData.length > 0
        ? this.postedData.every((item) => item.completed == true)
        : false;
    },
    measurementComputed : function () {
      const uom= this.unit_of_measurements.map((item) => {
        return { ...item, name: item.label.toUpperCase(), id: item.code };
      }, []);

      console.log("measurementComputed",uom)
      return uom;
    },
    
    checkSystemSupport : function(){
          return this.$helpers.isSystemAdministrator();
      },
  },
  
  watch: {
    brandComputed: function (v) {
      this.filteredBrands = v;
    },
    syncModal(val) {
      if (val && this.formStatus === "create") {
        this.initliazePopupTable();
      }
    },
    isAllCompleted: function (value) {
      if (value == true) {
        this.processing = false;
        this.$emit("success");
      }
    },

    connection : function (v) {
      const self = this;
      this.getUnitOfMeasurementGroups({
          'connection' : v
      }).then(response => {
            self.unit_of_measurements = response.map(e => {
                return {
                    label : `${e.UomEntry} - ${e.UomCode}`,
                    code : e.UomEntry,
                    UomEntry : e.UomEntry,
                    UgpEntry : e.UgpEntry,
                    
                }
            },[])
        })
    },



  },
};
</script>

<style scoped>
.custom-checkbox .custom-control-label::before {
  border-radius: 0.5rem !important;
  cursor: pointer;
}

.no-image-gallery i.far {
  font-size: 42px;
  color: #959595;
}
.mdb-time-picker .clockpicker-span-hours,
.mdb-time-picker .clockpicker-span-minutes {
  color: #4285f4 !important;
}
</style>
